import Dialog from '#lib/components/dialog.jsx';
import { cn } from '#lib/helpers/class.js';
import { Icon } from '@iconify-icon/react';

export default function PlacesPopUp(props) {
    const { isOpen, onClose, addPlace, types } = props;

    const handleAddPlace = (type) => {
        addPlace(type);
        onClose();
    };

    return (
        <Dialog isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="flex flex-col space-y-4 w-1/2 sm:w-1/2 md:w-2/5 lg:w-1/4 xl:w-1/6 max-w-[1500px] min-w-[400px]">
                <div className="pr-4">
                    <Dialog.CloseButton />
                    <b>{_t.edit.places.popupPlacesText()}</b>
                    <p className="pr-2 mt-1 text-sm text-justify">{_t.edit.places.popupPlacesDescription()}</p>
                </div>
                <div className="flex justify-evenly">
                    {types.map((type) => {
                        return (
                            <div
                                key={type}
                                className={cn(
                                    'flex flex-col mr-3 gap-3 items-center w-24 px-2 py-4 bg-slate-100 border border-slate-200 rounded-lg cursor-pointer hover:bg-primary-50 hover:border-primary-400'
                                )}
                                onClick={() => handleAddPlace(type)}
                            >
                                {type === 'info' && (
                                    <Icon
                                        icon="material-symbols:info-outline-rounded"
                                        width="1.2rem"
                                        height="1.2rem"
                                        className={'pt-[2px]'}
                                    />
                                )}
                                {type === 'suggestions' && (
                                    <Icon
                                        icon="material-symbols:account-balance-outline-rounded"
                                        width="1.2rem"
                                        height="1.2rem"
                                        className={'pt-[2px]'}
                                    />
                                )}
                                <p className={'text-xs'}>
                                    {_t.edit.places[type === 'suggestions' ? 'suggestion' : type]()}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
